import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { MatDialogModule } from '@angular/material/dialog';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { CxMaterialConfigProviders } from '@bbraun/cortex';
import { CxSnackbarModule, SNACKBAR_CONFIG } from '@bbraun/cortex/snackbar';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import {StoreDevtoolsModule} from '@ngrx/store-devtools';

import {environment} from '../environments/environment';
import { AppRoutingModule } from './app-routing.module';
import { AuthModule } from './modules/auth/auth.module';
import { SplashScreenModule } from './modules/shared/components/splash-screen/splash-screen.module';
import { CUSTOM_SNACKBAR_CONFIG } from './modules/shared/constants/snackbar-config/snackbar-config.constants';
import { HttpErrorInterceptor } from './modules/shared/interceptors/http-error.interceptor';
import { UserEffects } from './store/user/user.effects';
import { UserReducer } from './store/user/user.reducer';

@NgModule({
  imports: [
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    HttpClientModule,
    CxSnackbarModule,
    StoreModule.forRoot({'user': UserReducer}),
    EffectsModule.forRoot([UserEffects]),
    AuthModule.forRoot(),
    MatDialogModule,
    SplashScreenModule,
    StoreDevtoolsModule.instrument({
      maxAge: 25,
      logOnly: environment.production,
      connectInZone: true
    })
  ],
  providers: [
    { provide: HTTP_INTERCEPTORS, useClass: HttpErrorInterceptor, multi: true },
    { provide: SNACKBAR_CONFIG, useValue: CUSTOM_SNACKBAR_CONFIG },
    CxMaterialConfigProviders
  ]
})
export class AppModule { }
